module.exports = __webpack_public_path__ + "img/iso.96475e7b.png";